import React from "react";

/**
 * Official TREL logo — gold airplane mark (transparent PNG) + serif wordmark.
 * Sizes are tuned for premium luxury hierarchy:
 *  - sm: navbar (28px mark)
 *  - md: dashboards (40px)
 *  - lg: auth pages (56px)
 *  - xl: marketing hero (88px)
 */
const SIZES = {
  sm: { mark: 28, text: "text-xl", gap: "gap-2" },
  md: { mark: 40, text: "text-2xl", gap: "gap-2.5" },
  lg: { mark: 56, text: "text-3xl", gap: "gap-3" },
  xl: { mark: 88, text: "text-5xl", gap: "gap-4" },
};

export default function Logo({ size = "sm", showWordmark = true, tagline = false, className = "" }) {
  const s = SIZES[size] || SIZES.sm;
  return (
    <span className={`inline-flex items-center ${s.gap} ${className}`} aria-label="TREL">
      <img
        src="/trel-logo.png"
        alt="TREL"
        width={s.mark}
        height={s.mark}
        style={{ height: s.mark, width: "auto", objectFit: "contain" }}
        className="select-none"
        draggable={false}
      />
      {showWordmark && (
        <span className="flex flex-col leading-none">
          <span className={`font-serif tracking-tight text-[#071A2D] ${s.text}`}>TREL</span>
          {tagline && (
            <span className="hidden sm:block mt-1 text-[10px] tracking-[0.14em] uppercase text-[#064E3B]/80 font-medium">
              Travel. Reservations. Experiences. Lifestyle.
            </span>
          )}
        </span>
      )}
    </span>
  );
}
